module.exports = __webpack_public_path__ + "img/Savvy HSA User Infographic.cc9851c2.png";